import $ from 'jquery';
import { Notice, noticeManager } from './notice';
import { updateWishlistBadge } from './wishlist-actions';

$(document).ready(() => {
  const wishlistNotice = new Notice();
  const wishlistNoticeManager = (method, args) => noticeManager(wishlistNotice, method, args);

  /**
   * add articles to wishlist from details page
   *
   * @param  {Node} scope the scope in which to search for articles to reload
   * @return {void}
   */
  function addArticleToWishlist(scope = document) {
    $(scope).find('.js-addtowishlist').on('click', (event) => {
      const element = $(event.target);
      const countInput = element.parents('tr:first').find('form.js-wishlistform').find('input[name=am]')[0];
      const wishlistForm = element.parent().parent().parent().find('form')[0];
      const formData = new FormData(wishlistForm);
      const xhr = new XMLHttpRequest();

      // set the backend function to call (determined by the data-attribute on the cliecked item)
      wishlistForm.querySelector('input[name="fnc"]').value = element.attr('data-fnc');

      xhr.open(wishlistForm.method, wishlistForm.action, true);
      xhr.onload = () => {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.response);

          if (response.return === -1) {
            // show message, but leave the value in the form as it is.
            wishlistNoticeManager('setMessage', [response.message]);
            wishlistNoticeManager('setType', ['error']);
          } else if (response.return === 1) {
            // update badge
            updateWishlistBadge();

            // green
            wishlistNoticeManager('setMessage', [response.message]);
            wishlistNoticeManager('setType', ['success']);
          }

          if (document.body.classList.contains('has-tab-overlay')) {
            wishlistNoticeManager('render', ['.tabs__content.is--active']);
            wishlistNoticeManager('displayNoticeAtElementPosition', [countInput, '.tabs__content.is--active']);
          } else {
            wishlistNoticeManager('render');
            wishlistNoticeManager('displayNoticeAtElementPosition', [countInput]);
          }
        }
      };
      xhr.send(formData);

      return false;
    });
  }

  addArticleToWishlist();
});



// WEBPACK FOOTER //
// ./assets/js/components/product-detail.js